const DAY_NAME = '(?:Mon(?:day)?|Tue(?:sday)?|Wed(?:nesday)?|Thu(?:rsday)?|Fri(?:day)?|Sat(?:urday)?|Sun(?:day)?)';
const SCHEDULE_PREFIX = new RegExp(`(?:^|,\\s*)(${DAY_NAME}(?:\\s*-\\s*${DAY_NAME})?)\\s*:\\s*`, 'gi');

function formatTimeRange(value) {
  return value
    .replace(/(\d{1,2}(?::\d{2})?)\s*([ap])(?:\.?\s*m\.?)?/gi, (_, time, meridiem) => `${time} ${meridiem.toUpperCase()}M`)
    .replace(/\s*-\s*/g, ' – ')
    .replace(/\s*;\s*/g, ' · ');
}

/**
 * Split Junction's compact operating-hours text into display rows for draw-site cards.
 * Unrecognized provider copy is returned intact rather than guessed at.
 */
export function formatDrawSiteHours(value) {
  const text = String(value || '').trim();
  if (!text) return [];

  const schedules = [...text.matchAll(SCHEDULE_PREFIX)];
  if (!schedules.length) return [{ days: '', hours: text }];

  return schedules.map((schedule, index) => {
    const hoursStart = schedule.index + schedule[0].length;
    const nextSchedule = schedules[index + 1];
    const hoursEnd = nextSchedule ? nextSchedule.index : text.length;
    return {
      days: schedule[1].replace(/\s*-\s*/g, '–'),
      hours: formatTimeRange(text.slice(hoursStart, hoursEnd).replace(/,\s*$/, '').trim()),
    };
  }).filter((schedule) => schedule.hours);
}
